<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
    <path
      d="M7.063 10.75c0-3.188 1.188-5.125 2.313-6.125 1.375-1.5 3-2 4-2 .625 0 1.313-.625 1.313-1.313 0-.625-.5-1.313-1.313-1.313-3.625 0-8.938 3.438-8.938 10.75 0 9.688 7.625 20.438 7.938 20.75s.625.5 1.125.5c.375 0 .5 0 .875-.188.625-.5.625-1.313.313-1.813-.313-.125-7.625-10.563-7.625-19.25zM18.625 0C18 0 17.312.688 17.312 1.313c0 .688.688 1.313 1.313 1.313 1 0 2.625.5 4 2 .938 1 2.313 2.938 2.313 6.125 0 8.875-7.313 19.125-7.438 19.25-.5.688-.375 1.5.313 1.813.188.188.5.188.813.188.5 0 .813-.188 1.188-.5.313-.5 7.75-11.063 7.75-20.75 0-7.313-5.313-10.75-8.938-10.75zm2.813 10.75c0-3-2.438-5.5-5.438-5.5s-5.438 2.5-5.438 5.5c0 2.938 2.438 5.438 5.438 5.438s5.438-2.5 5.438-5.438zM16 13.5c-1.5 0-2.813-1.313-2.813-2.75 0-1.5 1.313-2.813 2.813-2.813s2.813 1.313 2.813 2.813c0 1.438-1.188 2.75-2.813 2.75z"
    />
  </svg>
</template>

<script>
export default {
  name: 'MapIcon',
};
</script>
